module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"update-order":"Update Order","order-updated":"Order updated","failed-update-order":"Failed to update order"}}')
  delete Component.options._Ctor
}
